

const CACHE_HORAS = 24;
if (!window._cacheMemoria) window._cacheMemoria = {};

export async function consultarConCache(ruta, consultarSimple) {
    const clave = `cache_${ruta}`;
    if (window._cacheMemoria[clave]) {
        return window._cacheMemoria[clave].data;
    }
    const guardado = localStorage.getItem(clave);

    if (guardado) {
        try {
            const { data, timestamp } = JSON.parse(guardado);
            const ahora = Date.now();
            const limite = CACHE_HORAS * 60 * 60 * 1000;

            if (ahora - timestamp < limite) {
                window._cacheMemoria[clave] = { data };
                return data;
            }
        } catch { }
    }
    const respuesta = await consultarSimple(ruta);

    let dataFinal = respuesta;

    if (ruta.startsWith("logs/")) {
        if (!respuesta) dataFinal = {};
        else {
            const compactado = {};
            Object.entries(respuesta).forEach(([correo, logs]) => {
                compactado[correo] = Object.keys(logs).length;
            });

            dataFinal = compactado;
        }
    }
    window._cacheMemoria[clave] = { data: dataFinal };
    try {
        localStorage.setItem(
            clave,
            JSON.stringify({
                data: dataFinal,
                timestamp: Date.now(),
            })
        );
    } catch (e) {
        if (e.name === "QuotaExceededError") {
            Object.keys(localStorage)
                .filter(k => k.startsWith("cache_logs/"))
                .forEach(k => localStorage.removeItem(k));
        }
    }

    return dataFinal;
}
